import { useEffect, useState } from "react";
import styles from "./project-list-page.module.css";
import { useProjectStore } from "entity-store/project-store/use-project-store";

import { PosterProject } from "PosterEditor/model/poster-project";
import { usePaths } from "BEDROCK/paths";
import { UIIconButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";

interface ProjectListPageProps {}

export const ProjectListPage = (props: ProjectListPageProps) => {
  const paths = usePaths();
  const { projects, createProject, deleteProject } = useProjectStore();

  const editProject = (project: PosterProject) => {
    paths.navigateTo(paths.mapEditor + "/" + project.id);
  };

  return (
    <div className={styles.container}>
      <List
        projects={projects ?? []}
        onClickAdd={async () => {
          await createProject.mutateAsync();
        }}
        onClick={(project) => {
          editProject(project);
        }}
        onClickDelete={async (project) => {
          await deleteProject.mutateAsync(project);
        }}
      />
    </div>
  );
};

interface ListProps {
  projects: PosterProject[];
  onClickAdd: () => void;
  onClick: (project: PosterProject) => void;
  onClickDelete: (project: PosterProject) => void;
}
const List = (props: ListProps) => {
  return (
    <div className={styles.gridContainer}>
      <button className={styles.item} onClick={props.onClickAdd}>
        ADD
      </button>
      {props.projects.map((project) => (
        <Item
          key={project.id}
          project={project}
          onClick={() => {
            props.onClick(project);
          }}
          onClickDelete={() => props.onClickDelete(project)}
        />
      ))}
    </div>
  );
};

interface ItemProps {
  project: PosterProject;
  onClick: () => void;
  onClickDelete: () => void;
}
const Item = (props: ItemProps) => {
  const mapStyle = props.project.mapStyle?.replace(
    /^mapbox:\/\/styles\/jamesbkelly\//,
    ""
  );

  const image = `/pallete-components/map-thumbnails/${mapStyle}.png`;
  return (
    <div className={styles.item}>
      <button className={styles.projectAction} onClick={props.onClick}>
        <img src={image} alt={props.project.name} />
      </button>
      <p>{props.project.id}</p>
      <UIIconButton
        iconName="BIN"
        onClick={props.onClickDelete}
        width={25}
        height={25}
      />
    </div>
  );
};
